module.exports = __webpack_public_path__ + "img/taken.b264ca5c.svg";